export class ObjectStoreExclusionRule {
    'id';
    'bucket';
    'modificationDate';
    'bucketPrefix';
    'include';
    'storeType';
    'matchType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "modificationDate",
            "baseName": "modificationDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "bucketPrefix",
            "baseName": "bucketPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "storeType",
            "baseName": "storeType",
            "type": "ObjectStoreExclusionRuleStoreTypeEnum",
            "format": ""
        },
        {
            "name": "matchType",
            "baseName": "matchType",
            "type": "ObjectStoreExclusionRuleMatchTypeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ObjectStoreExclusionRule.attributeTypeMap;
    }
    constructor() {
    }
}
export var ObjectStoreExclusionRuleStoreTypeEnum;
(function (ObjectStoreExclusionRuleStoreTypeEnum) {
    ObjectStoreExclusionRuleStoreTypeEnum["S3"] = "S3";
    ObjectStoreExclusionRuleStoreTypeEnum["Gcs"] = "GCS";
})(ObjectStoreExclusionRuleStoreTypeEnum || (ObjectStoreExclusionRuleStoreTypeEnum = {}));
export var ObjectStoreExclusionRuleMatchTypeEnum;
(function (ObjectStoreExclusionRuleMatchTypeEnum) {
    ObjectStoreExclusionRuleMatchTypeEnum["Prefix"] = "prefix";
    ObjectStoreExclusionRuleMatchTypeEnum["Regex"] = "regex";
})(ObjectStoreExclusionRuleMatchTypeEnum || (ObjectStoreExclusionRuleMatchTypeEnum = {}));
